
import { supabase } from '@/integrations/supabase/client';
import { SlackIntegration } from '../../types';
import { dbLogger } from '../utils/dbLogger';

/**
 * Updates specific settings for a Slack integration
 */
export const updateSlackSettings = async (
  aiStaffId: string, 
  settings: Partial<SlackIntegration>
): Promise<boolean> => {
  try {
    dbLogger.info("Updating Slack settings", { aiStaffId, settings });
    
    const { error } = await supabase
      .from('slack_integrations')
      .update({
        ...settings,
        updated_at: new Date().toISOString()
      })
      .eq('ai_staff_id', aiStaffId);
    
    if (error) {
      dbLogger.error("Error updating Slack settings", error);
      throw new Error(`Failed to update settings: ${error.message}`);
    }
    
    dbLogger.info("Successfully updated Slack settings", { aiStaffId });
    
    return true;
  } catch (error) {
    dbLogger.error("Exception in updateSlackSettings", error);
    throw error;
  }
};
